// Constants
import { HttpStatus } from "@ms/uno-constants/lib/local/HttpStatusConstants";
import { StoreEntityState, StoreEntityStatus } from "@ms/uno-constants/lib/local/StoreConstants";
// Utilities
import { Temporal } from "temporal-polyfill-lite";
import moment from "moment";
/**
 * Get the state based on a request response
 * @param response Response from the request
 */ export function getStateBasedOnResponse(response) {
    if (response.status === HttpStatus.NotFound) {
        return StoreEntityState.NotFound;
    }
    if (response.status === HttpStatus.Forbidden) {
        return StoreEntityState.Inaccessible;
    }
    return null;
}
/**
 * Get the status based on a request response
 * @param response Response from the request
 */ export function getStatusBasedOnResponse(response) {
    if (response.status === HttpStatus.NotFound) {
        return StoreEntityStatus.NotFound;
    }
    if (response.status === HttpStatus.Forbidden) {
        return StoreEntityStatus.Inaccessible;
    }
    return null;
}
/**
 * Get whether the status represents a failed state
 * @param status Status to check
 */ export function isStatusFailure(status) {
    return status === StoreEntityStatus.NotFound || status === StoreEntityStatus.Inaccessible || status === StoreEntityStatus.UnableToFetch;
}
/**
 * Get whether the status represents a fetching or unfetched state
 * @param status Status to check
 */ export function isStatusFetchingOrUnfetched(status) {
    return status === StoreEntityStatus.Fetching || status === StoreEntityStatus.Unfetched;
}
/**
 * Get status based on the fetched time and expiry time
 * @param timestamp Time the entity was fetched
 * @param expiryTime Time in seconds before the entity expires
 */ export function getStatusBasedOnTimestamp(timestamp, expiryTime) {
    return timestamp?.add(expiryTime, "s").isAfter(moment().utc()) ? StoreEntityStatus.Present : StoreEntityStatus.Stale;
}
/**
 * Update the status of an entity in the table
 * @param table The table containing entity statuses
 * @param id The identifier for the entity
 * @param newStatus The new status to set for the entity
 * @returns Whether the status was updated
 */ export function updateStatus(table, id, statusUpdates) {
    if (statusUpdates.isFetching === undefined && statusUpdates.state === undefined) {
        return false; // No updates to apply
    }
    const currentStatus = table.get(id);
    const isFetchingUpdated = !currentStatus || statusUpdates.isFetching !== undefined && statusUpdates.isFetching !== currentStatus.isFetching;
    const stateUpdated = !currentStatus || statusUpdates.state !== undefined && statusUpdates.state !== currentStatus.state;
    table.set(id, {
        isFetching: statusUpdates.isFetching ?? currentStatus?.isFetching ?? false,
        state: statusUpdates.state ?? currentStatus?.state ?? StoreEntityState.Absent,
        timestamp: Temporal.Now.instant()
    });
    return isFetchingUpdated || stateUpdated;
}
